// extracted by mini-css-extract-plugin
module.exports = {"textArea":"TagList_textArea__TnSkU","myBtn":"TagList_myBtn__HbjyW"};